var _a;
import api from "../../utils/api/api.utils";
import { generateApi } from "../generators/generator.api";
import { GENERATOR_PARAMS } from "./exportFile.constants";
export var getPaged = (_a = generateApi(GENERATOR_PARAMS), _a.getPaged), create = _a.create;
// A failed custom export back in the queue; only ever on request, the worker does not retry.
export var retry = function (params) {
    return api.post("/".concat(GENERATOR_PARAMS.basePathEntity, "/").concat(params.id, "/retry"), { isV2: true });
};
export var getFileUrl = function (params) {
    var id = params.id, file = params.file;
    return api.get("/".concat(GENERATOR_PARAMS.basePathEntity, "/").concat(id, "/file-url/").concat(file), {
        isV2: true,
    });
};
